import React, { createContext, useCallback, useContext, useState } from 'react';

const LoadingContext = createContext(null);

export function LoadingProvider({ children }) {
  const [count, setCount] = useState(0);

  // Wraps an async action so the overlay shows for its duration. Counter-based
  // so overlapping calls don't hide the overlay early.
  const withLoading = useCallback(async (fn) => {
    setCount((c) => c + 1);
    try {
      return await fn();
    } finally {
      setCount((c) => Math.max(0, c - 1));
    }
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading: count > 0, withLoading }}>
      {children}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const ctx = useContext(LoadingContext);
  if (!ctx) throw new Error('useLoading must be used within a LoadingProvider');
  return ctx;
}
